export default "__VITE_ASSET__1601907f__"